import React, {useEffect} from 'react';
import Chat from './Chat';
import DevInfo from './Components/DevInfo';
import CustomButton from './Components/CustomButton'
import Hero from './img/hero.svg';
import InfoBox from './Components/InfoBox';
import MethodBox from './Components/MethodBox';
import Phone from './img/phone.svg';
import Laptop from './img/laptop.svg';
import WorldMap from './img/particles1.png';
import InfoImg from './img/website-info.png';
import InfoImg1 from './img/website-info2.png';
import History from './History';
import Discuss from './img/discuss.svg';
import Design from './img/design.svg';
import Develop from './img/develop.svg';
import Aos from 'aos';
import "aos/dist/aos.css";
import Footer from './Footer';

function Home() {
    
    useEffect(() => {
        Aos.init({ duration: 700,
            delay:200});

    }, []);

    const bottom = () => {
        window.scroll({
          bottom: document.getElementById('.chatdiv'), // or document.scrollingElement || document.body
          left: 0,
          behavior: 'smooth'
        });
    };

    return (
        <div>
            <div className="home">
            <div className="home-bg"/>
                <div className="hero">
                    <div className="hero-text">
                        <div className="hero-header">
                            <p className="hero-h1" data-aos="fade-right" >
                                STOP
                            </p>
                            <p data-aos="fade-left" >
                                SEARCHING
                            </p>   
                            <p className="hero-h1" data-aos="fade-right">
                                START
                            </p>   
                            <p data-aos="fade-left">
                                SELLING
                            </p> 
                        </div>
                        <div data-aos="fade-up" data-aos-delay="500">  
                            <p className="hero-h2">
                            Custom Solutions Developed By Experts
                            </p> 
                            <a href='/Web'>
                            <CustomButton text="GET STARTED →" style={{backgroundColor:'#E92323'}}  history={History} />
                            </a>
                        
                        </div> 
                    </div>
                    <div className="hero-img">
                        <div className="hero-circle"/>
                        <img src={Hero} data-aos="fade-up"/>
                    </div>

            </div>

            
            </div>

            <div className="landing-dev" >
                <h2 data-aos="fade-up">YOUR CREATIVITY OUR CODE</h2>
                <InfoBox 
                    className="left"
                    title="WEB DEVELOPMENT" 
                    img={Laptop}
                    variant="double"
                    button={true}
                    text="An inspiring online presence that represents your business and stands out.
                    It all begins at the drawing board and finishes with a website matching your vision."
                    link="/Web"
                />
                <InfoBox 
                    className="right"
                    title="APP DEVELOPMENT" 
                    img={Phone}
                    button={true}
                    text="We create apps that can generate audiences or build on existing ones. Our premuim built apps are a great tool to exapand your business stratagies on a personal level."
                    link="/App"
                /> 
            </div>

            <div className="landing-map">
                <img src={WorldMap} style={{overflowX:"hidden"}}/>
                <div className="landing-map-text" data-aos="fade-up">
                    
                    <h2>LEAD BY EXPERTS</h2>
                    <div className="landing-map-title-split"/>
                    <p>All of our software projects are built by developers with years of experience. Our goal is to insure the best quality solutions possible. </p>
                </div>

            </div>

            <div className="landing-method">
                <div className="landing-method-text" data-aos="fade-up">
                    <h3>THE</h3>
                    <h2>ALSIP</h2>
                    <h3>METHOD</h3>
                </div>

        
                <MethodBox data-aos-delay="100" title="DISCUSS" text="The first stage of development is to talk. We schedule multiple meetings around your schedule to ensure we see the vision for your software. In these meetings we discuss time frame, execpations, price and our view on realistic development time. Throughout the entire process you will aways be kept in the loop." number="1" style="outlined" position="first" img={Discuss} />
                <MethodBox  data-aos-delay="100"title="DESIGN" text="If you don't already have designs, our team will draft backend data-diagrams and frontend UX/UI designs. This will represent the look and feel of what we intend to the final software to be. We value your opionion and will make changes to this until you are happy with the final result."  number="2" style="part-filled" position="second" img={Design}/>
                <MethodBox   data-aos-delay="100"title="DEVELOP" text="This is the exciting part. Once you are happy with the design, our expert developers will start work on building your software with the latest development tools and technologies. " number="3" style="filled" position="third" img={Develop}/> 
            
            </div>

            <Chat id="chatdiv"/>
            
        </div>
    )
}

export default Home;
